import { render, staticRenderFns } from "./SourceCodeDetail.vue?vue&type=template&id=1a12eaff&scoped=true"
import script from "./SourceCodeDetail.vue?vue&type=script&lang=js"
export * from "./SourceCodeDetail.vue?vue&type=script&lang=js"
import style0 from "./SourceCodeDetail.vue?vue&type=style&index=0&id=1a12eaff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a12eaff",
  null
  
)

export default component.exports